function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.79688 22.75V6.25H7.85938V22.75H5.79688ZM11.4688 28.25V0.75H13.5312V28.25H11.4688ZM0.125 17.25V11.75H2.1875V17.25H0.125ZM17.1406 22.75V6.25H19.2031V22.75H17.1406ZM22.8125 17.25V11.75H24.875V17.25H22.8125Z"
});

var SvgVolume = function SvgVolume(props) {
  return React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 25 29"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Volume.08324336.svg";
export { SvgVolume as ReactComponent };